<template lang="pug">
    div(class="vehicle-fit flex items-starts mb-3" :class="classObject")
        div
            div(class="fitIcon relative rounded-full p-5 w-[35px] h-[35px] md:p-3")
                xIcon(v-if="type === 'bad'" class="icon absolute m-auto inset-0 fill-current text-white")
                exclamationPoint(v-if="type === 'mismatch'" class="icon absolute m-auto inset-0 fill-current text-white")
                img(v-if="type === 'good'" src="@/assets/common/checkmarkThick.svg" alt="checkmark" class="icon absolute m-auto inset-0 fill-current text-white" loading="lazy")
                QuestionMark(v-if="type === 'more' || type === 'select'" class="icon absolute m-auto inset-0 fill-current text-white" style="width:10px")
        div(class="pl-6 w-full border-0 rounded-r-4")
            div
                div(class="font-bold text-dark")
                    div(v-if="type === 'select' || type === 'more'")
                        span(class="block uppercase font-bold") ENTER FITMENT
                        span(class="font-normal") See if this product fits your vehicle
                    span(v-if="type === 'bad' || type === 'mismatch'" class="uppercase") DOES NOT FIT YOUR VEHICLE
                    span(v-if="type === 'good'" class="uppercase") FITS YOUR VEHICLE
                    FilteredFitment(v-if="type === 'bad' || type ==='good'")
                    nuxt-link(v-if="type === 'bad'" :to="{ name: 'mmy', params: fitmentData }" class="font-normal") See products that fit your vehicle
                div(v-if="type !== 'more' && type !== 'select'" class="text-sm leading-4 mt-1 md:mt-0")
                    a(@click="$pageBus.$emit('changeVehicle')" class="inline-block md:self-center md:text-right") Change Vehicle

</template>

<script>
import FilteredFitment from './filteredFitment'
const xIcon = () => import(/* webpackChunkName: "x-icon" */ '@/assets/common/x?inline')
const QuestionMark = () =>
    import(/* webpackChunkName: "question-mark" */ '@/assets/common/questionMark?inline')
const exclamationPoint = () =>
    import(
        /* webpackChunkName: "exclamation-point-icon" */ '@/assets/common/exclamationPoint?inline'
    )

export default {
    components: {
        FilteredFitment,
        xIcon,
        QuestionMark,
        exclamationPoint,
    },
    inject: ['$pageBus'],
    props: {
        type: {
            type: String,
            validator: (value) => {
                return ['good', 'bad', 'more', 'mismatch', 'select'].includes(value)
            },
            default: 'good',
        },
    },
    computed: {
        classObject() {
            return {
                '-fitsGood': this.type === 'good',
                '-fitsBad': this.type === 'bad',
                '-fitsMore': this.type === 'more',
                '-fitsMismatch': this.type === 'mismatch',
                '-fitsSelect': this.type === 'select',
            }
        },
        fitmentData() {
            return this.$store.state.fitment.data
        },
    },
    mounted() {
        if (this.type === 'bad') this.$uiEvents.$emit('doesNotFitViewed', this.$route.fullPath)
    },
}
</script>

<style lang="stylus" scoped>
.vehicle-fit
    &.-fitsBad
        .fitIcon
            background-color theme('colors.danger.DEFAULT')
            .icon
                width 16px

    &.-fitsMismatch
        .fitIcon
            background-color theme('colors.warning.dark')
            .icon
                height 20px
                left: 2px

    &.-fitsGood
        .fitIcon
            background-color theme('colors.success.DEFAULT')
            .icon
                width 20px

    &.-fitsMore
        .fitIcon
            background-color theme('colors.gray.dark')
            .icon
                width 16px

    &.-fitsSelect
        .fitIcon
            background-color theme('colors.gray.dark')
            .icon
                width 16px
</style>
